<template>
  <div>
    <div>
      <div
        class="mwow-button-filled success"
        @click="closeDrawer"
        style="margin-bottom: 12px"
      >
        添加员工
      </div>
      <relate-dialog v-if="showRelateButton">
        <div class="mwow-button-filled">关联员工</div>
      </relate-dialog>
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
      <el-form
        :model="searchInfo"
        size="mini"
        ref="form"
        label-width="64px"
        @submit.native.prevent
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="员工搜索:">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="员工姓名/手机号"
                @change="handleSearch"
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                clearable
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="在职状态:">
              <el-radio-group
                v-model="searchInfo.on_job"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">在职</el-radio-button>
                <el-radio-button :label="2">离职</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="员工类型:" prop="directly_under">
              <el-radio-group
                v-model="searchInfo.directly_under"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">正式</el-radio-button>
                <el-radio-button :label="2">关联</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="员工岗位:">
              <el-radio-group
                v-model="searchInfo.job_id"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="3">课程顾问</el-radio-button>
                <el-radio-button :label="2">教务</el-radio-button>
                <el-radio-button :label="1">教师</el-radio-button>
                <el-radio-button :label="4">市场顾问</el-radio-button>
                <el-radio-button :label="5">校长</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="离职时间:" prop="resting_time">
              <!-- <el-date-picker
                v-model="searchInfo.resting_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.resting_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <div>
      <el-table
        size="mini"
        v-horizontal-scroll
        ref="multipleTable"
        tooltip-effect="dark"
        stripe
        style="width: 100%"
        :data="tableData"
      >
        <el-table-column label="员工姓名" prop="name" width="180">
          <template slot-scope="scope">
            {{ scope.row.name }}
            <span class="mwow-tag danger" v-show="!scope.row.is_activate"
              >未激活<i
                class="el-icon-question"
                style="cursor: pointer; margin-left: 4px"
                @click="showInviteTips"
              ></i
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="130" prop="mobile">
          <template slot-scope="scope">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile }}
          </template>
        </el-table-column>
        <el-table-column label="在职状态" width="90">
          <template slot-scope="scope">
            <div v-if="scope.row.directly_under === 1">
              <el-switch
                v-model="scope.row.on_job"
                disabled
                :class="[scope.row.is_init == 2 ? 'captcha' : 'gray']"
                @click.native="changeIsNeedCaptcha(scope.row)"
              >
              </el-switch>
            </div>
            <div v-else>
              <div class="mwow-green" v-show="scope.row.on_job">在职</div>
              <div class="mwow-gray" v-show="!scope.row.on_job">离职</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="离职时间"
          prop="resignation_time"
        ></el-table-column>
        <el-table-column label="员工类型" prop="directly_under">
          <template slot-scope="scope">{{
            scope.row.directly_under === 1 ? "正式员工" : "关联员工"
          }}</template>
        </el-table-column>
        <el-table-column label="员工岗位" prop="jobs" width="250">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.jobs
                  .map((item) => {
                    return item.job_name;
                  })
                  .join("，") || "-"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="员工性质" prop="full_time">
          <template slot-scope="scope">
            {{ scope.row.full_time === 1 ? "全职" : "兼职" }}
          </template>
        </el-table-column>
        <el-table-column label="身份权限">
          <template slot-scope="scope">
            <span v-for="(item, i) in scope.row.roles" :key="i">
              {{
                i == scope.row.roles.length - 1
                  ? item.role_name
                  : item.role_name + "，"
              }}
            </span>
            <span v-show="!scope.row.roles">-</span>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <div class="remarkBox">
              {{ scope.row.remark != "" ? scope.row.remark : "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <div class="next_follow">
              <div
                class="mwow-button success"
                style="margin-right: 10px"
                @click="edit(scope.row)"
              >
                编辑
              </div>
              <div
                class="mwow-button"
                style="margin-right: 10px"
                @click="createStaffCode(scope.row)"
                v-debounce="1000"
                v-if="
                  scope.row.on_job &&
                  scope.row.directly_under === 1 &&
                  showRelateButton
                "
              >
                生成员工码
              </div>
              <div
                v-if="scope.row.directly_under === 2"
                class="mwow-button danger"
                style="margin-right: 10px"
                @click="disrelate(scope.row)"
              >
                解除关联
              </div>
              <div
                v-if="!scope.row.is_activate"
                class="mwow-button success"
                style="margin-right: 10px"
                @click="handleInvite(scope.row)"
                v-debounce="1000"
              >
                邀请激活
              </div>
              <!-- 删除前提：直属当前门店 -->
              <div
                v-if="scope.row.directly_under === 1"
                class="mwow-button"
                @click="clickstaffdel(scope.row)"
                v-debounce="1000"
              >
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  modifyStatusClick,
  staffdel,
  beforeStaffDel,
  getStaffActivateLinkApi,
  createStaffRelateCodeApi,
} from "@/api/staffData";
import { getStaffList } from "@/api/staff";
import relateDialog from "./relateDialog.vue";
import { PageModule } from "@/store/module/page";
import { UserModule } from "@/store/module/user";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  props: ["visible"],
  components: {
    relateDialog,
    commonDateRangeSelector,
    commonSearchFormWrapper,
  },
  data() {
    return {
      searTypeenter: "", //判断输入时名字还是数字
      searchInfo: {
        on_job: -1,
        job_id: -1, // 是否授课默认值是
        key_word: "",
        directly_under: -1,
        resting_time: [],
      },
      tableData: [], //列表数据
      pageSize: 10,
      pageSizeArray: [10, 30, 50],
      total: 0,
      page: 1,
      isteachList: [
        { value: "是", key: 1 },
        { value: "否", key: 2 },
      ],
      drawer: false,
      dialogForm: {},
      onjobList: [
        { value: "在职", key: 1 },
        { value: "离职", key: 2 },
      ],
      effectiveDate: {
        disabledDate: (date) => {
          return date > Date.now();
        },
      },
    };
  },
  computed: {
    showRelateButton() {
      return UserModule.userInfo.inst_org_number > 1;
    },
  },
  created() {
    const employeesInfo = PageModule.pageInfo.storeEmployees;
    if (employeesInfo.search_info) {
      this.searchInfo = employeesInfo.search_info;
    }
    if (employeesInfo.page) {
      this.page = employeesInfo.page;
    }
    if (employeesInfo.page_size) {
      this.pageSize = employeesInfo.page_size;
    }
    const _t = this;
    const pageData = PageModule.pageInfo.storeStaff;
    if (pageData.page) {
      _t.page = pageData.page;
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        _t.getList({
          page: _t.page,
          page_size: _t.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      _t.getList({
        page: _t.page,
        page_size: _t.pageSize,
      });
    }
  },
  methods: {
    handleReset() {
      this.searchInfo = {
        on_job: -1,
        job_id: -1,
        key_word: "",
        directly_under: -1,
        resting_time: [],
      };
      this.handleSearch();
    },
    createStaffCode(val) {
      createStaffRelateCodeApi({
        staff_id: val.staff_id,
      }).then((res) => {
        const h = this.$createElement;
        const now = dateFormat("YYYY-mm-dd HH:MM:SS", new Date());
        this.$msgbox({
          title: "员工码生成",
          message: h("p", null, [
            h("p", null, `员工码：${res.data.code}`),
            h("p", null, `员工姓名：${val.name}`),
            h("p", null, `生成时间：${now}`),
          ]),
          showCancelButton: false,
          confirmButtonText: "复制员工码",
          confirmButtonClass: "mwow-button-filled success",
        })
          .then(() => {
            navigator.clipboard.writeText(res.data.code).then(() => {
              this.$message({
                type: "success",
                message: "复制成功",
              });
            });
          })
          .catch(() => {});
      });
    },
    edit(e) {
      const _t = this;
      if (e) {
        _t.$router.push({ name: "editEmployee", query: { id: e.staff_id } });
      } else {
        _t.$router.push({ name: "editEmployee", query: { id: 0 } });
      }
      this.cachePageInfo();
    },
    changeIsNeedCaptcha(e) {
      const _t = this;
      if (e.is_init == 1) {
        return;
      }
      if (e.on_job == true) {
        _t.$confirm(
          `确定关闭在职状态后，将失去门店权限。`,
          `在职状态 - ${e.name}`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            e.on_job = false;
            _t.modifyStatus(e);
          })
          .catch(() => {});
      } else {
        e.on_job = true;
        _t.modifyStatus(e);
      }
    },
    modifyStatus(e) {
      const _t = this;
      const on_job = e.on_job ? 1 : 2;
      modifyStatusClick({ staff_id: e.staff_id, on_job: on_job })
        .then((res) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
            e.on_job = !e.on_job;
          }
        })
        .catch(() => {
          this.handleRefresh();
        });
    },
    showInviteTips() {
      this.$alert(
        `员工资料信息已添加，需要员工授权激活加入门店，授权激活链接有效期为24小时，超过24小时后可点击【激活邀请】重新复制链接发送给员工激活。`,
        `提示说明-未激活`,
        {
          confirmButtonText: "我知道了",
        }
      );
    },
    handleInvite(row) {
      getStaffActivateLinkApi({
        staff_id: row.staff_id,
      }).then((res) => {
        const link = res.data.link;
        navigator.clipboard.writeText(link).then(() => {
          this.$message({
            type: "success",
            message:
              "激活链接已复制，该链接有效期为24小时，请发送给员工让及时激活",
          });
        });
      });
    },
    disrelate(row) {
      const _t = this;
      this.$confirm(
        `确定对${row.name}员工进行解除关联吗？`,
        `解除关联 - ${row.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          staffdel({ staff_id: row.staff_id }).then((res) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "解除关联成功!",
              });
              _t.getList(
                {
                  page: 1,
                  page_size: _t.pageSize,
                },
                () => {}
              );
            } else {
              _t.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    clickstaffdel(e) {
      const _t = this;
      if (e.on_job) {
        this.$message({
          type: "warning",
          message: "请先将员工设为离职状态再进行删除",
        });
        return false;
      }
      beforeStaffDel({
        staff_id: e.staff_id,
      }).then((res) => {
        const studentNum =
          res.data.edu_teacher_student_count +
          res.data.follow_staff_student_count;
        const classNum = res.data.class_num;
        const lessonNum = res.data.lesson_num;
        if (studentNum === 0 && classNum === 0 && lessonNum === 0) {
          _t.$confirm(
            `确定删除后，用户的所有权限将失效，此操作不能撤销。`,
            `删除 - 门店员工`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
            }
          )
            .then(() => {
              staffdel({ staff_id: e.staff_id }).then((res) => {
                if (res.error_code == 0) {
                  _t.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  _t.getList(
                    {
                      page: 1,
                      page_size: _t.pageSize,
                    },
                    () => {}
                  );
                } else {
                  _t.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              });
            })
            .catch(() => {});
        } else {
          let msg = "";
          if (studentNum) {
            msg = msg + `${studentNum}个学员，`;
          }
          if (classNum) {
            msg = msg + `${classNum}个班级，`;
          }
          if (lessonNum) {
            msg = msg + `${lessonNum}个课时，`;
          }
          _t.$alert(`该员工有绑定${msg}请先进行解绑`, `删除 - 门店员工`, {
            confirmButtonText: "我知道了",
            confirmButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
          });
        }
      });
    },
    handlePagerChange(e) {
      const _t = this;
      _t.page = e;
      this.cachePageInfo();
      _t.getList(
        {
          page: _t.page,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },
    handlePagerSizeChange(e) {
      this.cachePageInfo();
      const _t = this;
      _t.pageSize = e;
      _t.getList(
        {
          page: 1,
          page_size: e,
        },
        () => {}
      );
    },
    getList(data, cb) {
      const _t = this;
      if (_t.searchInfo.key_word) {
        data.key_word = _t.searchInfo.key_word;
      }
      if (_t.searchInfo.on_job >= 0) {
        data.on_job = _t.searchInfo.on_job;
      }
      if (_t.searchInfo.job_id >= 0) {
        data.job_id = _t.searchInfo.job_id;
      }
      if (_t.searchInfo.directly_under >= 0) {
        data.directly_under = _t.searchInfo.directly_under;
      }
      if (
        _t.searchInfo.resting_time &&
        _t.searchInfo.resting_time.length === 2
      ) {
        data.resignation_time_start =
          _t.searchInfo.resting_time[0].getTime() / 1000;
        data.resignation_time_end =
          _t.searchInfo.resting_time[1].getTime() / 1000 + 24 * 60 * 60 - 1;
      }
      getStaffList(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((item) => {
              // item.is_teach_name = item.is_teach == 1 ? "是" : "否";
              item.on_job = item.on_job == 1 ? true : false;
              item.resignation_time = item.resignation_time
                ? dateFormat("YYYY-mm-dd", item.resignation_time * 1000)
                : "-";
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (cb) {
            cb();
          }
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "storeEmployees",
        key: "search_info",
        value: { ...this.searchInfo },
      });
      PageModule.SET_PAGE_INFO({
        name: "storeEmployees",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "storeEmployees",
        key: "page_size",
        value: this.pageSize,
      });
    },
    closeDrawer() {
      this.cachePageInfo();
      const _t = this;
      _t.edit();
    },
    handleSearch() {
      const _t = this;
      this.getList(
        {
          page: 1,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },
    handleRefresh() {
      const _t = this;
      this.getList(
        {
          page: _t.page,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },
  },
};
</script>

<style scoped lang="scss">
.no-del {
  background-color: #f5f7fa !important;
  cursor: not-allowed !important;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .autocompletename {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .autocompleteaddr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .autocompleteaddr {
      color: #ddd;
    }
  }
}
.primary {
  margin-left: 20px;
}
.el-form .el-form-item__label {
  text-align: left !important;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 12px !important;
  margin-right: 80px !important;
}
.next_follow {
  display: flex;
  .btnsize {
    padding: 0 11px;
    line-height: 22px;
    margin-left: 10px;
  }
}
.remarkBox {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .captcha.el-switch.is-disabled {
  opacity: 1;
  .el-switch__core {
    cursor: pointer;
  }
}
/deep/.gray.el-switch.is-disabled {
  opacity: 1;
  .el-switch__core {
    cursor: not-allowed;
  }
}
.green {
  color: #07d1aa;
}
.origin {
  color: #ffb940;
}
/deep/.el-form {
  .el-form-item {
    margin-right: 38px;
    .el-input {
      width: 100%;
    }
  }
}
</style>
